export default "__VITE_ASSET__9d2e9429__"